export const CREATE_RESOURCES = "CREATE_RESOURCES"
export const RESOURCES_LISTING = 'RESOURCES_LISTING'
export const RES_RESOURCES_LISTING = "RES_RESOURCES_LISTING"
export const RES_RESOURCES_DOCUMENT = "RES_RESOURCES_DOCUMENT"
export const UPDATE_RESOURCES = 'UPDATE_RESOURCES'
export const RESOURCES_DOCUMENT = 'RESOURCES_DOCUMENT'